import {
	Divider,
	HStack,
	Avatar,
	Center,
	Flex,
	Icon,
	Text,
	VStack,
	IconButton,
	Box,
	useDisclosure,
} from '@chakra-ui/react'
import React, { useState, useRef } from 'react'
import { FaFileAlt } from 'react-icons/fa'
import { BsReply } from 'react-icons/bs'
import { MdReply, MdMoreVert } from 'react-icons/md'
import CustomMenu from '../../../components/menu'
import { getUTCtoIST, formatHHMM } from '../../../utils/date.utils'
import moment from 'moment'
import {
	dataLayerTagManager,
	GA_CATEGORY_TIMELINE,
	sectionDetailedTrack,
} from '../../../containers/repository/repo.utils'

import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuItemOption,
	MenuGroup,
	MenuOptionGroup,
	MenuDivider,
} from '@chakra-ui/react'
import SVGIcon from '../../../assets/svgIcons'

const FORM_PREFIX = {
	705: 'has been submitted',
	713: 'has been updated',
	726: 'has been resubmitted',
}

const FormTimelineUpdate = ({
	timeline,
	asset_id,
	onFormSelection = () => {},
	timelineReplyData,
}) => {
	const {
		operating_asset_first_name,
		timeline_stream_type_id,
		datetime_log,
		data_form_name,
		log_asset_id,
		data_entity_inline,
		data_form_transaction_id,
		timeline_transaction_id,
	} = timeline

	const [isHover, setIsHover] = useState(false)
	const showMenu = useRef(false)

	const { form_submitted, form_field_preview_enabled, content, subject } =
		JSON.parse(data_entity_inline) || {}

	const {
		isOpen: menuIsOpen,
		onOpen: menuOnOpen,
		onClose: menuOnClose,
	} = useDisclosure()

	let data_form_id
	let submitted_data = []
	if (typeof form_submitted === 'string') {
		let field = JSON.parse(form_submitted)[0]
		data_form_id = field.form_id
		submitted_data = JSON.parse(form_submitted)
	} else {
		let field = form_submitted[0] || {}
		data_form_id = field.form_id
		submitted_data = form_submitted
	}

	const getValue = data => {
		if (data && typeof data === 'string' && data.includes('s3.ap-south-1')) {
			return data.replace('"', '').split('/').reverse()[0]
		} else {
			try {
				let json_data = typeof data === 'string' ? JSON.parse(data) : data
				let d = Array.isArray(json_data)
					? json_data
							.map(s => s.operating_asset_first_name || s.lov_name)
							.join(', ')
					: JSON.stringify(json_data)
				return d
			} catch (e) {
				return data
			}
		}
	}

	const htmlDecode = content => {
		var rawMarkup = escape(content).replace(/%0A/g, '<br/>')
		return { __html: unescape(rawMarkup) }
	}

	let iconColor = log_asset_id === asset_id ? 'white' : '#009B76'
	let bg = log_asset_id === asset_id ? '#009B76' : 'white'

	const getCustomMenu = () => {
		return (
			<Menu isOpen={menuIsOpen}>
				<MenuButton
					className={`timeline-attachment-message-menu`}
					as={IconButton}
					icon={
						<SVGIcon
							iconName='UpArrowSvg'
							svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
							pathProps={{ fill: iconColor }}
						/>
					}
					bg={log_asset_id === asset_id ? '#009B76' : 'white'}
					_focus={{
						bg: { bg },
					}}
					_hover={{
						bg: { bg },
					}}
					_active={{
						bg: { bg },
					}}
					border='none'
					aria-label='Sort'
					size='xs'
					ml='auto'
					top='0px'
					right='0px'
					pt='8px'
					variant='outline'
					onClick={() => {
						showMenu.current = !showMenu.current
						showMenu.current ? menuOnOpen() : menuOnClose()
					}}
				/>
				<MenuList
					overflowY='auto'
					maxHeight='50vh'
					boxShadow='0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);'
					borderRadius='18px'
				>
					<MenuItem
						size='sm'
						py={1}
						color='#009B76'
						icon={<Icon as={BsReply} w={5} h={5} color='#009B76' />}
						onClick={e => {
							sectionDetailedTrack({
								category: GA_CATEGORY_TIMELINE,
								action: 'Form Timeline Update',
								label: 'Reply',
							})
							timelineReplyData({
								...timeline,
								title: `${data_form_name} ${FORM_PREFIX[timeline_stream_type_id]}`,
							})
						}}
					>
						Reply
					</MenuItem>
				</MenuList>
			</Menu>
		)
	}

	const showUpArrow = () => {
		setIsHover(true)
	}

	const hideUpArrow = () => {
		showMenu.current = false
		menuOnClose()
		setIsHover(false)
	}
	return (
		<Flex
			className={`timeline-attachment-message-container`}
			id={`reply_item${timeline_transaction_id}`}
			justifyContent='flex-start'
			alignItems='flex-start'
			my={4}
			flexDirection={log_asset_id === asset_id ? 'row-reverse' : 'row'}
		>
			<VStack
				className={`timeline-attachment-message-file-details`}
				justifyContent='space-around'
				alignItems='center'
				bg={log_asset_id === asset_id ? '#009B76' : 'white'}
				borderRadius={
					log_asset_id === asset_id
						? '15px 15px 0px 15px'
						: '0px 12px 12px 12px'
				}
				minh='170px'
				maxh='250px'
				minW='200px'
				maxW='500px'
				mx={2}
				px='1rem'
				py={2}
				mr='2rem'
				position='relative'
				cursor={'pointer'}
				onMouseEnter={() => showUpArrow()}
				onMouseLeave={() => hideUpArrow()}
			>
				{log_asset_id !== asset_id && (
					<HStack justifyContent='space-between' w='100%'>
						<Text color='brand.700' fontSize='0.875rem' fontWeight='500'>
							{operating_asset_first_name}
						</Text>
						<Box visibility={isHover ? 'visible' : 'hidden'}>
							{getCustomMenu()}
						</Box>

						{/* <CustomMenu
              className={`timeline-attachment-message-menu`}
              icon={MdMoreVert}
              color="brand.800"
              borderRadius="md"
              boxShadow={0}
              aria-label="More"
              bg={log_asset_id === asset_id ? 'gray.700' : 'white'}
              size="sm"
              top="0px"
              right="0px"
              optionList={[
                {
                  label: `Reply`,
                  isMenu: true,
                  icon: <Icon as={MdReply} w={5} h={5} color="brand.900" />,
                  onClick: e => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_TIMELINE,
                      action: 'Form Timeline Update',
                      label: 'Reply',
                    })
                    timelineReplyData({
                      ...timeline,
                      title: `${data_form_name} ${FORM_PREFIX[timeline_stream_type_id]}`,
                    })
                  },
                },
              ]}
              selected={{}}
            /> */}
					</HStack>
				)}

				<HStack>
					<Flex
						alignSelf='flex-start'
						justifyContent='center'
						align='center'
						h='90px'
						cursor='pointer'
						onClick={() => {
							sectionDetailedTrack({
								category: GA_CATEGORY_TIMELINE,
								action: 'Form Timeline Update',
								label: 'Open Form View',
							})
							dataLayerTagManager('button_click', {
								viewName: 'File Timeline',
								buttonName: 'Open Form View',
							})
							if (!!data_form_id) {
								onFormSelection({
									form_id: data_form_id,
									form_name: data_form_name,
									form_transaction_id: data_form_transaction_id,
									submitted_data: submitted_data,
									is_from_timeline: true,
								})
							}
						}}
					>
						<Icon
							as={FaFileAlt}
							color={log_asset_id === asset_id ? 'white' : 'brand.800'}
							h='4rem'
							w='3rem'
							mr='1rem'
						/>
					</Flex>
					<VStack
						wordBreak='break-all'
						alignSelf='flex-start'
						alignItems='flex-start'
						flex={1}
						pr={10}
					>
						<Text
							fontSize='sm'
							fontWeight='600'
							color={log_asset_id === asset_id ? 'white' : 'black'}
						>{`${data_form_name} ${FORM_PREFIX[timeline_stream_type_id]}`}</Text>

						<Text
							// textAlign="left"
							fontSize='12px'
							color={log_asset_id === asset_id ? 'white' : 'black'}
							dangerouslySetInnerHTML={htmlDecode(getValue(content))}
						/>
						{form_field_preview_enabled && form_field_preview_enabled.length ? (
							<VStack alignItems='flex-start' w='full'>
								<Divider />
								{form_field_preview_enabled.map((d, i) => {
									var hours = 0
									var minutes = 0
									if (
										!!d.field_value &&
										typeof d.field_value === 'string' &&
										d.field_value.includes('start_date_time') &&
										d.field_value.includes('end_date_time')
									) {
										d['field_value'] = JSON.parse(d.field_value)
									}
									hours =
										!!d.field_value && !!d.field_value.duration
											? Math.floor(Number(d.field_value.duration) / 60)
											: 0
									minutes =
										!!d.field_value && !!d.field_value.duration
											? Number(d.field_value.duration) % 60
											: 0
									let f_value =
										typeof d.field_value === 'object'
											? JSON.stringify(d.field_value)
											: d.field_value
									let text = escape(f_value).replace(/%5Ct/g, ' ')
									d['field_value'] =
										!!d.field_value && !!d.field_value.duration
											? d.field_value
											: unescape(text)
									let leaveParse = data => {
										try {
											let val = JSON.parse(data)
											if (!!val.leave_data && Array.isArray(val.leave_data)) {
												let valArr = Array.isArray(val.leave_data)
													? val.leave_data.filter(Boolean)
													: []
												return valArr
													.map(
														l =>
															l.leave_type_name +
															' - ' +
															l.leave_applied +
															' days'
													)
													.join(', \n')
											} else {
												return data
											}
										} catch (err) {
											return data
										}
									}
									d['field_value'] = leaveParse(d.field_value)
									return (
										<Text fontWeight='700' key={i}>
											{d.field_name} :{' '}
											{!!d.field_value && !!d.field_value.duration ? (
												<>
													<Text fontWeight='400'>
														{`Start Datetime: `}
														<Text as='span' fontWeight='400' color='brand.800'>
															{`${moment(d.field_value.start_date_time).format(
																'DD/MM/YYYY hh:mm A'
															)}`}
														</Text>
													</Text>
													<Text fontWeight='400'>
														{`Duration: `}
														<Text as='span' fontWeight='400' color='brand.800'>
															{`${hours} Hr ${minutes} Min`}
														</Text>
													</Text>
													<Text fontWeight='400'>
														{`End Datetime: `}
														<Text as='span' fontWeight='400' color='brand.800'>
															{`${moment(d.field_value.end_date_time).format(
																'DD/MM/YYYY hh:mm A'
															)}`}
														</Text>
													</Text>
												</>
											) : (
												<Text
													as='span'
													fontWeight='400'
													color='brand.800'
													wordBreak='break-word'
													dangerouslySetInnerHTML={htmlDecode(
														getValue(d.field_value)
													)}
												/>
											)}
										</Text>
									)
								})}
							</VStack>
						) : null}
					</VStack>
					{log_asset_id === asset_id && (
						<Box
							visibility={isHover ? 'visible' : 'hidden'}
							alignSelf='flex-start'
						>
							{getCustomMenu()}
						</Box>
					)}
				</HStack>
				<Text
					className={`timeline-attachment-message-text-time-log`}
					fontSize='10px'
					mb={0}
					alignSelf='flex-end'
					color={log_asset_id === asset_id ? 'white' : 'black'}
				>
					{formatHHMM(getUTCtoIST(datetime_log))}
				</Text>
			</VStack>
		</Flex>
	)
}

export default FormTimelineUpdate
